import { render } from "./SelectTemplate.vue?vue&type=template&id=2241669c&scoped=true"
import script from "./SelectTemplate.vue?vue&type=script&lang=js"
export * from "./SelectTemplate.vue?vue&type=script&lang=js"

import "./SelectTemplate.vue?vue&type=style&index=0&id=2241669c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2241669c"]])

export default __exports__